import { Request } from '@mam/main/ApiClient';

export type ChangePriorityResponse = Record<never, never>;

export enum ChangePriorityError {}

export class ChangePriorityRequest implements Request<ChangePriorityResponse, ChangePriorityResponse> {
	public readonly api = 'pigeon';
	public readonly body;
	public readonly knownErrorCodes = Object.values(ChangePriorityError);
	public readonly method = 'put';
	public readonly path: string;

	public constructor(priority: boolean, notificationIds: string[]) {
		this.body = JSON.stringify({
			notificationIds,
			priority: priority ? 'high' : 'normal',
		});
		this.path = `notifications/priority`;
	}
}
